import { useAppDispatch } from "@hooks/redux";
import { useSerializeCallback } from "@kalodata/tools";
import { fetchLinkedAccounts, TIKTOK_PLATFORM } from "@store/linkedAccountSlice";

export function useTikTokAccounts() {
  const dispatch = useAppDispatch();
  const getTikTokAccounts = useSerializeCallback(async () => {
    const data = await dispatch(fetchLinkedAccounts()).unwrap();
    return data.filter((item) => item.platform === TIKTOK_PLATFORM);
  });
  return getTikTokAccounts;
}
